export default __webpack_public_path__ + "static/OIL_Northern-25beec952e4da3441952209756769627.jpg";